import { useSelector } from 'react-redux';

import { DOUBLE_DASH } from 'consts/placeholders';
import { formatDate, formatNumber } from 'modules/I18N';
import { Network } from 'components/common/types/Network.types';
import { TimelineItem } from 'lib/Timeline';
import { Store } from 'components/common/types/Store.types';

type NetworkInfoProps = {
  network: Network;
};

const NetworkInfo = ({ network }: NetworkInfoProps): React.ReactElement => {
  const { localeCode } = useSelector((state: Store) => state.publisher.configuration);
  return (
    <TimelineItem
      title={
        <div className="grid grid-cols-3 gap-x-4">
          <p className="body-sm">Network code</p>
          <p className="body-sm">Network name</p>
        </div>
      }
    >
      <div className="grid grid-cols-3 gap-x-4 gap-y-2">
        <p className="body-base" data-test-id="asset-network-uuid">
          {network.networkUuid}
          <br />
          <span className="body-sm text-neutral-950-opacity-60">{`${formatDate(
            network.startDate,
            localeCode,
          )} - ${formatDate(network.endDate, localeCode)}`}</span>
        </p>
        <p className="body-base col-span-2" data-test-id="asset-network-name">
          {network.networkName ?? DOUBLE_DASH}
        </p>
        <div>
          <p className="body-sm">Price Factor</p>
          <p className="body-base mt-2 mb-0.5" data-test-id="asset-network-price-factor">
            {formatNumber({ value: network.priceFactor, localeCode })}
          </p>
        </div>
        <div className="col-span-2">
          <p className="body-sm">Network group</p>
          <p className="body-base mt-2" data-test-id="asset-network-group-name">
            {network.networkGroupName ?? DOUBLE_DASH}
          </p>
        </div>
      </div>
    </TimelineItem>
  );
};

export default NetworkInfo;
